import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center" }
const _hoisted_2 = { class: "m-4 flex justify-center items-center gap-4" }
const _hoisted_3 = { class: "m-4 flex justify-center items-center flex-wrap" }
const _hoisted_4 = { class: "m-4 flex flex-col justify-center items-center" }

import { computed } from "vue";
import { LedRule, Condition } from "@/keyboard";
import { keysDescription } from "@/keyboard/keys_utils";
import { REPEAT } from "@/keyboard/leds";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import ListSelect from "@/components/utils/ListSelect.vue";
import ConditionEdit from "@/components/leds/ConditionEdit.vue";
import KeysEdit from "@/components/leds/KeysEdit.vue";
import TransitionsEdit from "@/components/leds/TransitionsEdit.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LedRuleEdit',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Hacky way to avoid "unexpected property mutation" warnings when using v-model.
// It works correctly anyway, as we are accessing the reactive objects in rule's fields.
const rule = computed(() => props.modelValue);

const keys = computed(() =>
  rule.value.keys == undefined ? null : rule.value.keys
);
// TODO: add warning about no keys selected (like in keyboard config, see warnings.ts)
const keysText = computed(() => keysDescription(keys.value));

const updateCondition = (c?: Condition) => {
  console.log("updateCondition", JSON.stringify(c, null, 2));
  const rule = Object.assign({}, props.modelValue, {
    condition: c ?? "Always",
  });
  emit("update:modelValue", rule);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "py-3 pt-4 px-10 rounded-t-box bg-base-content/10 w-full" }, [
      _createElementVNode("div", {
        class: "tooltip",
        "data-tip": "Keys to which the rule applies"
      }, [
        _createElementVNode("span", { class: "font-semibold" }, "Keys")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(keysText.value), 1),
      _createVNode(KeysEdit, {
        modelValue: rule.value.keys,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rule.value.keys) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "py-3 px-10 bg-base-content/10 w-full" }, [
      _createElementVNode("div", {
        class: "tooltip",
        "data-tip": "Condition required for the rule to be active"
      }, [
        _createElementVNode("span", { class: "font-semibold" }, "Condition")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ConditionEdit, {
        modelValue: _ctx.modelValue.condition,
        "onUpdate:modelValue": updateCondition
      }, null, 8, ["modelValue"])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "py-3 px-10 bg-base-content/10 w-full" }, [
      _createElementVNode("div", {
        class: "tooltip",
        "data-tip": "Color pattern used for a LED when the rule applies"
      }, [
        _createElementVNode("span", { class: "font-semibold" }, "Pattern")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(SettingsOption, {
        label: "Repeat",
        tooltip: "Defines how the pattern should be repeated",
        class: "w-auto"
      }, {
        default: _withCtx(() => [
          _createVNode(ListSelect, {
            class: "w-40",
            modelValue: rule.value.pattern.repeat,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rule.value.pattern.repeat) = $event)),
            options: _unref(REPEAT),
            clearable: false
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _createVNode(SettingsOption, {
        label: "Transitions",
        tooltip: "Color transitions - transition reaches given color after some time, interpolating from current color",
        class: "w-auto"
      }),
      _createVNode(TransitionsEdit, {
        modelValue: rule.value.pattern.transitions,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rule.value.pattern.transitions) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})